export enum ChartModes {
    COLUMNS = 'COLUMNS',
    POINTS = 'POINTS'
}
